export default "__VITE_ASSET__CgZcOjW___"